// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6751":"100065f3","7375":"b1521ff4","9131":"b1521ff4"}[chunkId] + ".chunk.css";
};